import css from 'styled-jsx/css'
import { colors } from 'theme'

const maskOpaqueImageStyles = css`
  .mask-opaque-image {
    box-shadow: inset 0rem 0rem 3rem 2rem rgba(0,0,0, 0.2);
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    color: ${colors.black};
    transition: all 0.2s;
  }
  .mask-block-image-gray-background {
    box-shadow: inset 0rem 0rem 10rem 10rem rgba(0,0,0, 0.5);
    color: ${colors.alpha(colors.black, 0.5)};
  }
`

export default maskOpaqueImageStyles